import React, {Component} from "react";
import {Buffer} from "buffer";
import Cookies from "universal-cookie";
import {idealChatServices} from "../../services/ideal/IdealChatService";
import {Button, Card, Col, Divider, Dropdown, Empty, Image, MenuProps, Modal, Row, Spin} from "antd";
import {CaretDownOutlined} from "@ant-design/icons";
import {offerApiServices} from "../../services/offer/OfferApiService";

class FetchDataIdeal extends Component<any, any> {
    private readonly initState!: any;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString())

    constructor(props: any) {
        super(props);
        this.initState = {
            offerCode: "",
            offerData: {},
            phoneNumber: "",
            loading: false,
            dataIdeal: {},
            showModalConfirmCopyOwnerImage: false,
            showModalConfirmCopyOwnerData: false,
            doProcess: false,
        }
        this.state = {...this.initState}
    }

    async componentDidMount() {
        await this.promisedSetState({
            offerCode: this.props.offerCode,
            phoneNumber: this.props.phoneNumber,
            offerData: this.props.offerData
        });
        await this.fetchIdealData();
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.time !== prevProps.time) {
            await this.promisedSetState({
                offerCode: this.props.offerCode,
                phoneNumber: this.props.phoneNumber,
                offerData: this.props.offerData
            });
            await this.fetchIdealData();
        }
    }

    async fetchIdealData() {
        await this.promisedSetState({
            loading: true,
            dataIdeal: {},
        });

        await idealChatServices.getDataCustomer({
            phoneNumber: this.state.phoneNumber,
        }).then(async value => {
            if (value.data?.success?.data) {
                this.setState({
                    loading: false,
                    dataIdeal: value.data?.success?.data,
                });
            } else {
                this.setState({
                    loading: false,
                    dataIdeal: {},
                });
            }
        }).catch(async e => {
            this.setState({
                loading: false,
                dataIdeal: {},
            });
        });
    }


    confirmCopyOwnerData = async () => {
        await this.promisedSetState({
            doProcess: true,
        });

        const dataUpdateDataOwner = {
            update_type: "id-card-owner",
            company: "amarta",
            dealer_code: "",
            offer_code: this.state.offerCode,
            admin_id: this.user,
            admin_name: this.user,
            id_card_owner: {
                id_card_number: this.state.dataIdeal?.dataOwner?.IdCard?.IdCardNumber ?? "",
                id_card_image: this.state.dataIdeal?.dataOwner?.IdCard?.IdCardImage ?? "",
                full_name: this.state.dataIdeal?.dataOwner?.IdCard?.FullName ?? "",
                full_address: this.state.dataIdeal?.dataOwner?.IdCard?.FullAddress ?? "",
                birth_place: this.state.dataIdeal?.dataOwner?.IdCard?.PlaceOfBirth ?? "",
                birth_date: this.state.dataIdeal?.dataOwner?.IdCard?.DateOfBirth ?? "",
                marital_status_code: this.state.dataIdeal?.dataOwner?.IdCard?.MaritalStatus ?? "",
                marital_status: this.state.dataIdeal?.dataOwner?.IdCard?.MaritalStatus ?? "",
                occupation_code: this.state.dataIdeal?.dataOwner?.IdCard?.Occupation ?? "",
                occupation: ""
            },
            address_owner: {
                full_address: this.state.dataIdeal?.dataOwner?.IdCard?.FullAddress ?? "",
                province_code: this.state.dataIdeal?.dataOwner?.IdCard?.Province?.Code ?? "",
                province_name: this.state.dataIdeal?.dataOwner?.IdCard?.Province?.Name?.toLowerCase() ?? "",
                city_code: this.state.dataIdeal?.dataOwner?.IdCard?.City?.Code ?? "",
                city_name: this.state.dataIdeal?.dataOwner?.IdCard?.City?.Name?.toLowerCase() ?? "",
                district_code: this.state.dataIdeal?.dataOwner?.IdCard?.District?.Code ?? "",
                district_name: this.state.dataIdeal?.dataOwner?.IdCard?.District?.Name?.toLowerCase() ?? "",
                sub_district_code: this.state.dataIdeal?.dataOwner?.IdCard?.SubDistrict?.Code ?? "",
                sub_district_name: this.state.dataIdeal?.dataOwner?.IdCard?.SubDistrict?.Name?.toLowerCase() ?? "",
                zip_code: this.state.dataIdeal?.dataOwner?.IdCard?.ZipCode ?? "",
            }
        }

        try {
            await offerApiServices.updateOffer(dataUpdateDataOwner)
                .then(successData => {
                    Modal.success({
                        title: 'Proses Sukses',
                        content: 'Offer berhasil di update '
                    });
                    this.setState({
                        doProcess: false,
                        showModalConfirmCopyOwnerImage: false,
                    });
                    this.props.onCloseProps("close");
                });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: '' + e
            });
            await this.promisedSetState({
                doProcess: false,
            });
        }
    }

    confirmCopyOwnerImage = async () => {
        await this.promisedSetState({
            doProcess: true,
        });

        const dataUpdateImageOwner = {
            update_type: "id-card-owner",
            company: "amarta",
            dealer_code: "",
            offer_code: this.state.offerCode,
            admin_id: this.user,
            admin_name: this.user,
            id_card_owner: {
                id_card_number: this.state?.offerData?.id_card_owner?.id_card_number ?? "",
                id_card_image: this.state.dataIdeal?.dataOwner?.IdCard?.IdCardImage ?? "",
                full_name: this.state?.offerData?.id_card_owner?.full_name ?? "",
                full_address: this.state?.offerData?.id_card_owner?.full_address ?? "",
                birth_place: this.state?.offerData?.id_card_owner?.birth_place ?? "",
                birth_date: this.state?.offerData?.id_card_owner?.birth_date ?? "",
                marital_status_code: this.state?.offerData?.id_card_owner?.marital_status_code ?? "",
                marital_status: this.state?.offerData?.id_card_owner?.marital_status ?? "",
                occupation_code: this.state?.offerData?.id_card_owner?.occupation_code ?? "",
                occupation: this.state?.offerData?.id_card_owner?.occupation ?? ""
            },
            address_owner: {
                full_address: this.state?.offerData?.address_owner?.full_address ?? "",
                province_code: this.state?.offerData?.address_owner?.province_code ?? "",
                province_name: this.state?.offerData?.address_owner?.province_name ?? "",
                city_code: this.state?.offerData?.address_owner?.city_code ?? "",
                city_name: this.state?.offerData?.address_owner?.city_name ?? "",
                district_code: this.state?.offerData?.address_owner?.district_code ?? "",
                district_name: this.state?.offerData?.address_owner?.district_name ?? "",
                sub_district_code: this.state?.offerData?.address_owner?.sub_district_code ?? "",
                sub_district_name: this.state?.offerData?.address_owner?.sub_district_name ?? "",
                zip_code: this.state?.offerData?.address_owner?.zip_code ?? ""
            }
        }

        try {
            await offerApiServices.updateOffer(dataUpdateImageOwner)
                .then(successData => {
                    Modal.success({
                        title: 'Proses Sukses',
                        content: 'Offer berhasil di update '
                    });
                    this.setState({
                        doProcess: false,
                        showModalConfirmCopyOwnerImage: false,
                    });
                    this.props.onCloseProps("close");
                });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: '' + e
            });
            await this.promisedSetState({
                doProcess: false,
            });
        }
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        const items: MenuProps['items'] = [
            {key: '1', label: (<span onClick={() => this.setState({showModalConfirmCopyOwnerImage: true})}> Jadikan Image KTP Pemilik</span>)},
            {key: '2', label: (<span onClick={() => this.setState({showModalConfirmCopyOwnerData: true})}> Jadikan Full Data Pemilik</span>)},
        ];

        return (
            <React.Fragment>
                <div style={this.state.loading ? {textAlign: "center", padding: 20, minHeight: 200} : {display: 'none'}}>
                    <Spin style={{marginTop: 20}} size={'large'} tip="Loading..."/>
                </div>
                <div style={!this.state.loading && !this.state.dataIdeal?.dataOwner?.IdCard?.IdCardNumber ? {} : {display: 'none'}}>
                    <Empty/>
                </div>
                <div style={!this.state.loading && this.state.dataIdeal?.dataOwner?.IdCard?.IdCardNumber ? {} : {display: 'none'}}>
                    <Row>
                        <Col span={24}>
                            <Card size="small" hoverable={true}>
                                Data Pemilik
                                <Dropdown menu={{items}} placement="bottomLeft" arrow>
                                    <Button style={{float: "right"}} size={"small"} type={"primary"}> <CaretDownOutlined/> Aksi</Button>
                                </Dropdown>
                                <Divider style={{marginTop: 10, marginBottom: 10}}/>
                                <Row>
                                    <Col span={18}>
                                        <i className={`font-75-grey`}>Nomor KTP</i><br/>
                                        <span className={`text-80-black`}>{this.state.dataIdeal?.dataOwner?.IdCard?.IdCardNumber}</span><br/>
                                        <i className={`font-75-grey`}>Nama KTP</i><br/>
                                        <span className={`text-80-black`}>{this.state.dataIdeal?.dataOwner?.IdCard?.FullName}</span><br/>
                                        <i className={`font-75-grey`}>Tempat Tanggal Lahir</i><br/>
                                        <span className={`text-80-black`}>{this.state.dataIdeal?.dataOwner?.IdCard?.PlaceOfBirth} {this.state.dataIdeal?.dataOwner?.IdCard?.DateOfBirth?.slice(0, 10)}</span><br/>
                                    </Col>
                                    <Col span={4}>
                                        <Image src={this.state.dataIdeal?.dataOwner?.IdCard?.IdCardImage}/>
                                    </Col>
                                    <Col span={24}>
                                        <i className={`font-75-grey`}>Alamat</i><br/>
                                        <span className={`text-80-black`}>{this.state.dataIdeal?.dataOwner?.IdCard?.DomicileProvince?.Name}, {this.state.dataIdeal?.dataOwner?.IdCard?.DomicileCity?.Name}, {this.state.dataIdeal?.dataOwner?.IdCard?.DomicileDistrict?.Name}, {this.state.dataIdeal?.dataOwner?.IdCard?.SubDistrict?.Name}</span><br/>
                                        <span className={`text-80-black`}>{this.state.dataIdeal?.dataOwner?.IdCard?.FullAddress} {this.state.dataIdeal?.dataOwner?.IdCard?.DomicileZipCode}</span><br/>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                </div>

                <Modal
                    open={this.state.showModalConfirmCopyOwnerImage}
                    title="Konfirmasi Copy Data Ideal"
                    onOk={() => this.setState({showModalConfirmCopyOwnerImage: false})}
                    cancelText={'Tutup'} okText={false}
                    maskClosable={false}
                    closable={false}
                    footer={[
                        <Button onClick={this.confirmCopyOwnerImage} type={"primary"} loading={this.state.doProcess} key="1">Jadikan Image KTP Pemilik Offer</Button>,
                        <Button loading={this.state.doProcess} key="2" onClick={() => this.setState({showModalConfirmCopyOwnerImage: false})}>Close</Button>,
                    ]}
                >
                    Anda Yakin Akan menjadikan image KTP Ideal ini sebagai Image pemilik offer ? <br/><br/>
                </Modal>

                <Modal
                    open={this.state.showModalConfirmCopyOwnerData}
                    title="Konfirmasi Copy Data Ideal"
                    onOk={() => this.setState({showModalConfirmCopyOwnerData: false})}
                    cancelText={'Tutup'} okText={false}
                    maskClosable={false}
                    closable={false}
                    footer={[
                        <Button onClick={this.confirmCopyOwnerData} type={"primary"} loading={this.state.doProcess} key="1">Jadikan Image KTP Pemilik Offer</Button>,
                        <Button loading={this.state.doProcess} key="2" onClick={() => this.setState({showModalConfirmCopyOwnerData: false})}>Close</Button>,
                    ]}
                >
                    Anda Yakin Akan menjadikan image KTP Ideal ini sebagai Image pemilik offer ? <br/><br/>
                </Modal>
            </React.Fragment>
        );
    }
}

export default FetchDataIdeal;